import React from 'react';
import { Button, Snackbar } from '@yaradigitallabs/ahua-react';

export type NotificationType = 'success' | 'destructive';

interface NotificationProps {
  message: string | string[];
  type?: NotificationType;
  onClose: () => void;
  topOffset?: number;
}

export const Notification: React.FC<NotificationProps> = ({
  message,
  type = 'success',
  onClose,
  topOffset = 10,
}) => {
  const notificationLabel = `${type.charAt(0).toUpperCase() + type.slice(1)} Notification`;
  const messages = Array.isArray(message) ? message : [message];

  return (
    <Snackbar
      colorConcept={type}
      label={notificationLabel}
      open
      placement="topRight"
    >
      <Snackbar.Content
        colorConcept={type}
        label={notificationLabel}
        open
        placement="topRight"
        style={{
          paddingHorizontal: '12px',
          marginTop: `${topOffset}px`,
        }}
      >
        <Snackbar.Body>
          <Snackbar.Description>
            {messages.map((line, index) => (
              <div key={`${line}-${index}`}>{line}</div>
            ))}
          </Snackbar.Description>
        </Snackbar.Body>
        <Snackbar.Tail>
          <Snackbar.Close>
            <Button
              colorConcept="inverse"
              size="xs"
              variant="ghost"
              onClick={onClose}
            >
              Close
            </Button>
          </Snackbar.Close>
        </Snackbar.Tail>
      </Snackbar.Content>
    </Snackbar>
  );
};
